import React from 'react';
import Spline from '@splinetool/react-spline';
import { ArrowRight, CircuitBoard, Zap } from 'lucide-react';

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex flex-col lg:flex-row items-center pt-24 pb-12 px-6 lg:px-[7.69%] overflow-hidden border-b border-border-medium">

      {/* Terminal aesthetic layers */}
      <div className="hero-grid-bg" aria-hidden="true" />
      <div className="hero-glow" aria-hidden="true" />

      {/* Left Content */}
      <div className="w-full lg:w-1/2 z-10 flex flex-col gap-6 relative">
        <div
          className="inline-flex items-center gap-2 w-fit"
          style={{
            padding: '4px 12px',
            border: '1px solid var(--border-medium)',
            background: 'var(--bg-panel)',
            color: 'var(--brand-primary)',
            fontSize: '10px',
            fontWeight: 700,
            letterSpacing: '1.5px',
            textTransform: 'uppercase',
          }}
        >
          <span className="w-1.5 h-1.5 bg-brand-primary animate-pulse" />
          Next Gen Automation
        </div>

        <h1 className="display-huge">
          Automate.<br />
          <span className="text-brand-primary">Scale.</span><br />
          Dominate.
        </h1>

        <p className="body-large text-text-secondary max-w-xl">
          We build intelligent agentic workflows that replace operational bottlenecks with scalable, autonomous systems. Stop managing work. Start managing outcomes.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 mt-2">
          <a href="#contact" className="btn-primary group">
            Start Automation Audit
            <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" />
          </a>
          <a href="#case-studies" className="btn-secondary">
            View Case Studies
          </a>
        </div>

        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 mt-6 text-text-muted">
          <div className="flex items-center gap-2">
            <CircuitBoard className="w-3.5 h-3.5 text-brand-primary" />
            <span className="text-[10px] tracking-widest uppercase">Custom LLM Integration</span>
          </div>
          <div className="flex items-center gap-2">
            <Zap className="w-3.5 h-3.5 text-brand-primary" />
            <span className="text-[10px] tracking-widest uppercase">RT Data Processing</span>
          </div>
        </div>
      </div>

      {/* Right Spline Content */}
      <div className="w-full lg:w-1/2 h-[50vh] lg:h-[80vh] relative mt-12 lg:mt-0 z-10">
        <div className="absolute inset-0 lg:-right-20">
          <Spline scene="https://prod.spline.design/NbVmy6DPLhY-5Lvg/scene.splinecode" />
        </div>
        <div className="absolute inset-0 bg-brand-primary/5 blur-[100px] -z-10 rounded-full transform translate-x-20" />
      </div>
    </section>
  );
}
